import {
  type ConnectorLike,
  readyForConnectionTest,
} from "../../shared/connectors/isDraft";
import { useHasAccess } from "./useHasAccess";
import { useMyGrantForConnector } from "./useMyConnectorGrants";

export function useVisitorTestReadiness(
  app: (ConnectorLike & { id: string }) | undefined
) {
  const visitor = app?.authorizationMode === "visitor";
  const canManage = useHasAccess("connected_app:write", app?.id);
  const [callerGrant] = useMyGrantForConnector(app?.id, { enabled: visitor });
  const visitorReady =
    !!app && canManage && readyForConnectionTest(app, callerGrant);
  return { visitor, canManage, visitorReady };
}
